import getUrlWithFiltersGiftUtil from 'modules/gift/utils/get-url-with-filters'
import getPathnameWithQueryLocationUtil from 'utils/location/get-pathname-with-query'
import getHashStringUtil from 'utils/string/get-hash'
import { CART_HASH_VALUE_ACTION } from 'modules/cart/constants'
import logUtil from 'utils/log'

/**
 *
 * @param props
 * @param props.filters
 * @param props.hasCartInfo
 * @param props.currentSidebarId
 * @returns {string|*}
 */
const getPermalinkExpressCheckoutSelectUtil = (props = {}) => {
  const {
    filters,
    hasCartInfo
  } = props

  logUtil('getPermalinkExpressCheckoutSelectUtil').debug('[start] props=', props)

  if (!hasCartInfo) {
    logUtil('getPermalinkExpressCheckoutSelectUtil').debug('[noop] no cartInfo')
    return
  }

  /**
   * @param props
   * @param props.url
   * @param props.queryParams
   * @returns {*|string}
   */
  const getUrl = (props) => {
    const {
      url,
      queryParams
    } = props

    return getUrlWithFiltersGiftUtil({
      url,
      filters,
      queryParams
    })
  }

  const url = getPathnameWithQueryLocationUtil()
  return getUrl({
    url: `${url}${getHashStringUtil(CART_HASH_VALUE_ACTION.CREATE_EXPRESS_CHECKOUT_PERMALINK)}`
  })
}

export default getPermalinkExpressCheckoutSelectUtil
